module.exports = __webpack_public_path__ + "static/img/yunpic2.9fda093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunpic2.jpg
// module id = FjtM
// module chunks = 0